import tokens from './tokens';

export const chartTheme: ChartTheme = {
  tokens,
};
